// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__irjwH","rootMobile":"styles_rootMobile__2VwJH"};